import { getLatestState, updateState } from '../gameState'
import keyboard from '../lib/keyboard'
import { sounds } from './sound'
import { walrusBody } from './p2'

const controls = {
	left: keyboard('ArrowLeft'),
	right: keyboard('ArrowRight'),
}
document.body.addEventListener('touchstart', e => {
	if (e.touches[0].clientX < window.innerWidth / 2) controls.left.press()
	else controls.right.press()
})

document.body.addEventListener('touchend', e => {
	if (controls.left.isDown) controls.left.release()
	else controls.right.release()
})

const minCharge = 20
let charge = minCharge
const maxChargeFrames = 60
const xMax = 400
const yMax = 800

let direction = 1

const input = (deltaTime: number) => {
	const { player } = getLatestState()
	charge = player.jumpCharge

	if (player.isGrounded) {
		if (player.isSlippery) walrusBody.velocity[0] *= 0.99
		else walrusBody.velocity[0] *= 0.7
	}

	const { left, right } = controls

	if (right.isDown || left.isDown) charge += deltaTime
	if (charge > maxChargeFrames) charge = maxChargeFrames
	if (left.isDown) direction = -1
	if (right.isDown) direction = 1

	if (left.isUp && right.isUp && charge > minCharge && player.isGrounded) {
		walrusBody.velocity[0] = xMax * (charge / maxChargeFrames) * direction
		walrusBody.velocity[1] = -yMax * (charge / maxChargeFrames)
		player.isGrounded = false
		charge = minCharge
		sounds.jump()
	}

	updateState({ player: { ...player, jumpCharge: charge, direction } })
}

export default input
